<template>
  <v-tooltip
    v-bind="{ ...$props, ...$attrs }"
    content-class="datapeople-tooltip"
    max-width="208px"
  >
    <template
      #activator="{ props: hover }"
    >
      <span v-bind="hover">
        <slot name="activator" />
      </span>
    </template>
    <slot />
  </v-tooltip>
</template>

<style lang="less" scoped>
// detached tooltips in VOverlay
.v-tooltip > :deep(.v-overlay__content) {
  box-shadow: 0px 0px 50px fade(@text-darkest, 10%);
  background: @white !important;
  opacity: 1 !important;
  z-index: 10 !important;
  padding: 24px !important;
  width: 208px;
  border-radius: 10px;
  color: @text-darkest;
  text-align: center;
  font-weight: 300;

  :deep(span), :deep(p), :deep(strong) {
    font-size: 14px;
    line-height: 20px;
  }

  :deep(strong) {
    font-weight: 400;
  }
}

.datapeople-tooltip.v-tooltip__content {
  box-shadow: 0px 0px 50px fade(@text-darkest, 10%);
  background: @white;
  opacity: 1 !important;
  z-index: 10 !important;
  padding: 24px !important;
  width: 208px;
  border-radius: 10px;
  color: @text-darkest;

  :deep(span), :deep(p), :deep(strong) {
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    font-weight: 300;
  }

  :deep(strong) {
    font-weight: 400;
  }
}
</style>
